<template>
    <v-container fluid>
        <SToolbar>
            <KpIcon icon-cls="ic-20 ic-dashboard ic-col-grey" />
            <v-toolbar-title>{{ $t('dashboard') }}</v-toolbar-title>
        </SToolbar>

        <!-- top row, 3 cols with cards -->
        <v-row>
            <v-col cols="12" lg="4" class="d-flex">
                <GenericCard
                    color="white"
                    :href="globalParam('saiten.werbung_url')"
                    target="_blank"
                    class="flex-grow-1"
                >
                    <v-card-text>
                        <p class="card-title">
                            <KpIcon icon-cls="rocket" color="black" /> {{ $t('publish_commercial') }}
                        </p>
                        <p>
                            Hier findest du alle Informationen zum Thema Werbung & Inserate auf saiten.ch und in unserem
                            Kulturmagazin, inkl. Mediendaten und Kontakt. Mit einer Buchung ermöglichst du den Betrieb
                            von Saiten.
                        </p>
                        <p>
                            <KpIcon icon-cls="arrow-bigright" color="grey" />
                            Jetzt Werbung buchen
                        </p>
                    </v-card-text>
                </GenericCard>
            </v-col>
            <v-col cols="12" lg="4" class="d-flex">
                <GenericCard
                    color="white"
                    :href="globalParam('saiten.newsletter_url')"
                    target="_blank"
                    class="flex-grow-1"
                >
                    <v-card-text>
                        <p class="card-title"><KpIcon icon-cls="compass" color="black" /> Newsletter abonnieren</p>
                        <p>
                            Jeden Dienstag (Kulturnewsletter) und jeden Freitag (Wochenschau) versenden wir einen
                            aktuellen Überblick der neusten Artikel auf saiten.ch, Veranstaltungstipps und weitere
                            Hinweise auf aktuelle Veranstaltungen.
                        </p>
                        <p>
                            <KpIcon icon-cls="arrow-bigright" color="grey" />
                            Jetzt für einen Newsletter anmelden
                        </p>
                    </v-card-text>
                </GenericCard>
            </v-col>
            <v-col cols="12" lg="4" class="d-flex">
                <GenericCard
                    :href="globalParam('saiten.kalender_url')"
                    target="_blank"
                    class="frontpage-card flex-grow-1"
                    color="var(--frontpage-card-bg)"
                >
                    <v-card-text>
                        <v-card-text>
                            <p><KpIcon icon-cls="link" color="white" /> {{ $t('to_webseite') }}</p>
                        </v-card-text>
                    </v-card-text>
                </GenericCard>
            </v-col>
        </v-row>

        <!-- 2nd row: event table and more cards -->
        <v-row>
            <v-col cols="12" lg="9">
                <EventList
                    session-key="event-home"
                    display-context="dashboard"
                    height="calc(var(--usable-height-with-double-toolbar) - 200px)"
                />
            </v-col>
            <v-col cols="12" lg="3" class="d-flex flex-column" style="gap: 25px">
                <GenericCard color="white" :href="globalParam('saiten.erinnerungsmail_url')" target="_blank">
                    <v-card-text>
                        <p class="card-title">
                            <KpIcon icon-cls="rocket" color="black" /> Anmeldung Erinnerungsmail für Veranstalter:innen
                        </p>
                        <p>
                            11x pro Jahr erinnern wir dich an den Kalender- und Inserateschluss von unserem Printmagazin
                            und versorgen dich mit weiteren relevanten Infos aus dem Saiten-Universum.
                        </p>
                        <p>
                            <KpIcon icon-cls="arrow-bigright" color="grey" />
                            Jetzt für das freundliche Erinnerungsmail anmelden
                        </p>
                    </v-card-text>
                </GenericCard>
                <PublishInfoCard height="180px" />
            </v-col>
        </v-row>
    </v-container>
</template>

<script lang="ts">
import Vue from 'vue';
import { mapState } from 'vuex';
import GenericCard from '@/components/home/GenericCard.vue';
import EventList from '@/components/event/List.vue';
import PublishInfoCard from '@/components/home/PublishInfoCard.vue';
import { globalParam } from '@/helpers/globals';

export default Vue.extend({
    name: 'HomeViewVeranstalter',
    components: {
        EventList,
        GenericCard,
        PublishInfoCard,
    },
    computed: {
        ...mapState({
            user: (state: any) => state.user.record,
        }),
    },
    methods: {
        globalParam,
    },
});
</script>

<style lang="scss" scoped>
.frontpage-card {
    p {
        font-size: 1rem;
        color: white;
    }
    // background-image: url('~@/assets/minasa-dashboard-box-2.3.png');
    background-repeat: no-repeat;
    background-size: cover;
}

.publish-info-card {
    background-image: none;
}
</style>
